/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Locale-aware comparison that treats digit runs as numbers.
 * Use as an ag-grid column comparator so values like X1-9 sort before X1-89.
 */
export function compareNaturalText(left: unknown, right: unknown): number {
    return String(left ?? '').localeCompare(String(right ?? ''), undefined, {
        numeric: true,
        sensitivity: 'base'
    });
}
